import { supabase } from '../api/initSupabase';
import { localAnalytics } from './analytics';

export const getLastChapter = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from('chapter_user')
      .select(
        `
        chapter_id,
        chapter (
          book_id,
          number,
          book (slug)
        )
      `
      )
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .limit(1)
      .single();

    if (error || !data) return null;

    return {
      bookSlug: data.chapter.book.slug,
      chapterNumber: data.chapter.number,
    };
  } catch (error) {
    console.error('Error fetching last chapter:', error);
    return null;
  }
};

export const handleLastChapterRedirection = async (
  userId: string,
  navigate: (path: string) => void,
  forceRedirect: boolean = false
) => {
  localAnalytics().logEvent('LastChapterRedirection', {
    userId,
    forceRedirect,
  });
  const redirectedToBook = localStorage.getItem('redirectedToBook');
  if (!redirectedToBook || forceRedirect) {
    const lastChapter = await getLastChapter(userId);
    localStorage.setItem('redirectedToBook', 'true');
    if (lastChapter) {
      navigate(
        `/books/${lastChapter.bookSlug}/chapter/${lastChapter.chapterNumber}`
      );
    } else {
      navigate('/');
    }
  }
};
